import * as React from "react";
import { Col, Row, Button } from "reactstrap";
import { useHistory } from "react-router";

export interface IManagerCardProps {
  manager: any;
  refElement?: any;
}

export const ManagerCard = ({ manager, refElement }: IManagerCardProps) => {
  const history = useHistory();
  return (
    <Col xl="4" lg="6" md="12" sm="12" xs="12">
      <div className="info-card white-background" ref={refElement}>
        <Row>
          <Col md="12">
            <div className="manager-name">{manager.name}</div>
            <div className="manager-data">
              <p>
                <label>Agency:</label>
                {
                  manager.agencyCode === 'ALL' || 
                  manager.agencyCode === 'LEA' ? 
                  <span className="subFont">{manager.agencyCode}</span> 
                  :
                  <a href="#" onClick={() => history.push(`/agencies/info/${manager.agencyCode}`)}>
                    <span className="subFont">{manager.agencyCode}</span>
                  </a>
                }
              </p>
              <p>
                <label>Email:</label>
                <a href={`mailto:${manager.email}`}>
                  <span className="subFont">{manager.email}</span>
                </a>
              </p>
              <p>
                <label>Phone:</label>
                <span className="subFont">{manager.phone ? manager.phone : "Unknown"}</span>
              </p>
            </div>
          </Col>
        </Row>
        <Row className="top-space">
          <Col md="6" />
          <Col md="6">
            <Button
              className="btn btn-outline btn-blue btn-secondary"
              onClick={() => history.push(`/agencies/managers/info/${manager.managerId}`)}
            >
              View
            </Button>
          </Col>
        </Row>
      </div>
    </Col>
  );
};

export default ManagerCard;
